import { createApiHooks, httpStatusAsData } from '@apis/next/common';
import {
  CustomsRequest,
  CustomsRequestAction,
  CustomsRequestSecureData,
  CustomsRequestURLSubmitResult,
  PatchCustomsRequest,
  PostCustomsRequest,
  PutCustomsRequestBody,
} from '@models/next/CustomsRequest';
import { f } from '@utils/nextForms';
import { z } from 'zod';

export const customsRequestApis = createApiHooks('/customs-request', [
  {
    method: 'get',
    path: '/secure-data/:secure_data_key',
    parameters: [
      {
        type: 'Path',
        name: 'secure_data_key',
        schema: z.string(),
      },
    ],
    response: CustomsRequestSecureData,
  },
  {
    method: 'put',
    path: '/complete/:secure_data_key',
    parameters: [
      {
        type: 'Path',
        name: 'secure_data_key',
        schema: z.string(),
      },
    ],
    response: CustomsRequest,
  },
  {
    method: 'get',
    path: '/download-zip/:secure_data_key',
    parameters: [
      {
        type: 'Path',
        name: 'secure_data_key',
        schema: z.string(),
      },
    ],
    response: f.instanceOfBlob(),
  },
]);

export const dashboardCustomsRequestApis = createApiHooks('/dashboard/customs-request', [
  {
    method: 'post',
    path: '/',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PostCustomsRequest,
      },
    ],
    response: CustomsRequest,
  },
  {
    method: 'get',
    path: '/:d2d_no',
    parameters: [
      {
        type: 'Path',
        name: 'd2d_no',
        schema: z.string(),
      },
    ],
    response: CustomsRequest.nullable(),
  },
  {
    method: 'patch',
    path: '/:d2d_no',
    parameters: [
      {
        type: 'Path',
        name: 'd2d_no',
        schema: z.string(),
      },
      {
        type: 'Body',
        name: 'body',
        schema: PatchCustomsRequest,
      },
    ],
    response: CustomsRequest,
  },
  {
    method: 'put',
    path: '/:d2d_no',
    parameters: [
      {
        type: 'Query',
        name: 'action',
        schema: CustomsRequestAction,
      },
      {
        type: 'Body',
        name: 'body',
        schema: PutCustomsRequestBody,
      },
    ],
    response: CustomsRequest,
  },
]);

dashboardCustomsRequestApis.client.use(
  'get',
  '/dashboard/customs-request/:d2d_no',
  httpStatusAsData(404, null),
);

export const dashboardCustomsRequestURLSubmitApis = createApiHooks('/dashboard/customs-request', [
  {
    method: 'put',
    path: '/:d2d_no',
    parameters: [
      {
        type: 'Query',
        name: 'action',
        schema: z.enum(['URL_SUBMIT']),
      },
      {
        type: 'Body',
        name: 'body',
        schema: PutCustomsRequestBody,
      },
    ],
    response: CustomsRequestURLSubmitResult,
  },
]);
